import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HiMenuAlt3 } from "react-icons/hi";
import { AiOutlineClose } from "react-icons/ai";
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa";
import { IoLogoTwitter } from "react-icons/io";

const seal =
  "https://bu-page-assets.s3.ap-northeast-1.amazonaws.com/static-assets/others/Benadir University Logo.png";

const navItems = [
  { label: "Home", to: "/academics/postgraduate", end: true },
  { label: "About", to: "/academics/postgraduate/about" },
  { label: "Our Programs", to: "/academics/postgraduate/programs" },
  { label: "Graduate Thesis", to: "/academics/postgraduate/thesis" },
  { label: "BU Journal", to: "/academics/postgraduate/journal" },
];

const socials = [
  {
    href: "https://www.facebook.com/BenadirUniv",
    label: "Facebook",
    Icon: FaFacebookF,
  },
  { href: "https://twitter.com/BenadirUniv", label: "X", Icon: IoLogoTwitter },
  {
    href: "https://www.instagram.com/benadiruniv/",
    label: "Instagram",
    Icon: FaInstagram,
  },
  {
    href: "https://www.youtube.com/@benadiruniv",
    label: "YouTube",
    Icon: FaYoutube,
  },
];

const navClass = ({ isActive }) =>
  `pg-nav-link shrink-0 px-3 py-3 text-[15px] font-semibold tracking-wide transition ${
    isActive ? "active text-[#0863AA]" : "text-[#0a3d6b] hover:text-[#0863AA]"
  }`;

const PostgradHeader = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="pg-portal-header fixed inset-x-0 top-0 z-40">
      <div className="bg-[#0863AA]">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-2.5 sm:px-6">
          <Link
            to="/academics/postgraduate"
            className="flex min-w-0 items-center gap-3 text-white"
            onClick={() => setOpen(false)}
          >
            <img
              src={seal}
              alt="Benadir University"
              className="h-14 w-14 rounded-full bg-white object-contain p-0.5 sm:h-[68px] sm:w-[68px]"
            />
            <div className="min-w-0 leading-tight">
              <p
                dir="rtl"
                className="truncate text-sm font-semibold text-white sm:text-base"
              >
                برنامج الدراسات العليا والبحث العلمي
              </p>
              <p className="truncate text-sm font-medium text-sky-100 sm:text-[15px]">
                Postgraduate Studies &amp; Research
              </p>
            </div>
          </Link>

          <div className="flex items-center gap-3 sm:gap-5">
            <div className="pg-call">
              <p className="text-xs font-medium text-sky-100">Call Now</p>
              <a
                href="tel:+252615559323"
                className="text-lg font-bold tracking-wide text-white"
              >
                +252-61-5559323
              </a>
            </div>
            <Link
              to="/"
              className="rounded bg-white px-4 py-2 text-sm font-bold text-[#0863AA] shadow-sm transition hover:bg-sky-50 sm:px-5 sm:py-2.5"
            >
              BU Website
            </Link>
            <button
              type="button"
              className="pg-menu-btn rounded border border-white/30 p-2 text-white"
              aria-label={open ? "Close menu" : "Open menu"}
              onClick={() => setOpen((v) => !v)}
            >
              {open ? <AiOutlineClose size={22} /> : <HiMenuAlt3 size={22} />}
            </button>
          </div>
        </div>
      </div>

      <div className="pg-nav-bar">
        <div className="pg-nav-inner">
          <nav className="flex items-center overflow-x-auto">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={navClass}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3 text-[#0863AA]">
            {socials.map(({ href, label, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="transition hover:text-[#0a3d6b]"
              >
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>

        {open && (
          <nav className="pg-nav-mobile border-t border-sky-100 px-4 py-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={navClass}
                onClick={() => setOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href="tel:+252615559323"
              className="px-3 py-2 text-sm font-semibold text-[#0863AA]"
            >
              Call +252-61-5559323
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default PostgradHeader;
